import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=39a506f7&scoped=true&lang=pug"
import script from "./Thumbnail.vue?vue&type=script&lang=js"
export * from "./Thumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a506f7",
  null
  
)

export default component.exports